var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65343 21.3333C7.8001 20.68 7.53343 19.7467 7.06676 19.28L3.82676 16.04C2.81343 15.0267 2.41343 13.9467 2.70676 13.0133C3.01343 12.08 3.9601 11.44 5.37343 11.2L9.53343 10.5067C10.1334 10.4 10.8668 9.86666 11.1468 9.31999L13.4401 4.71999C14.1068 3.39999 15.0134 2.66666 16.0001 2.66666C16.9868 2.66666 17.8934 3.39999 18.5601 4.71999L20.8534 9.31999C21.0268 9.66666 21.3868 9.99999 21.7734 10.2267L7.41343 24.5867C7.22676 24.7733 6.90676 24.6 6.9601 24.3333L7.65343 21.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9334 19.28C24.4534 19.76 24.1867 20.68 24.3467 21.3334L25.2667 25.3467C25.6534 27.0134 25.4134 28.2667 24.5867 28.8667C24.2534 29.1067 23.8534 29.2267 23.3867 29.2267C22.7067 29.2267 21.9067 28.9734 21.0267 28.4534L17.1201 26.1334C16.5067 25.7734 15.4934 25.7734 14.8801 26.1334L10.9734 28.4534C9.4934 29.32 8.22673 29.4667 7.4134 28.8667C7.10673 28.64 6.88007 28.3334 6.7334 27.9334L22.9467 11.72C23.5601 11.1067 24.4267 10.8267 25.2667 10.9734L26.6134 11.2C28.0267 11.44 28.9734 12.08 29.2801 13.0134C29.5734 13.9467 29.1734 15.0267 28.1601 16.04L24.9334 19.28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cafb87d89a45ceb0d56c6ccf79030f1d.svg";
export { ForwardRef as ReactComponent };